function Palau({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1871)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#338AF3"/>
  <path d="M12.5218 22.9569C16.3638 22.9569 19.4783 19.8424 19.4783 16.0004C19.4783 12.1585 16.3638 9.04395 12.5218 9.04395C8.67984 9.04395 5.56531 12.1585 5.56531 16.0004C5.56531 19.8424 8.67984 22.9569 12.5218 22.9569Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Palau;
